export default __webpack_public_path__ + "static/Sleep  A Perfect Way To Regulate Emotions And Health-a65ea40bb2e42ffbf0d54690d35bf2ef.jpg";